import React from "react";

// Customizable Area Start
import {
  Modal,
  Container,
  Box,
  Button,
  Typography,
  Input,
  Grid,
  TextField,
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { createTheme, styled } from "@material-ui/core/styles";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import MicNoneOutlinedIcon from "@material-ui/icons/MicNoneOutlined";
import MicOffOutlinedIcon from "@material-ui/icons/MicOffOutlined";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0000ff",
      contrastText: "#fff",
    },
  },
});
import SideNavbar from "../../../components/src/SideNavbar.web";
import Sidebar from "../../../components/src/ChatNavBar";
import { ChatItem } from "../../../components/src/MessageItem";
import { UserChat } from "../../../components/src/UserChat";

export const PasswordDialogStyle = styled(Box)({
"& .dialog-header": {
    textAlign: "center",
    padding: "16px 24px",
    backgroundColor: "#f5f5f5",
  },
  "& .dialog-title": {
    fontSize: "24px",
    fontWeight: 600,
    fontFamily: "Jost",
    color: "#333",
  },
  "& .dialog-message": {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Jost",
    color: "#555",
    margin: "16px 0",
  },
  "& .dialog-actions": {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 24px",
  },
  "& .accept-btn": {
    backgroundColor: "#4CAF50",
    color: "#FFF",
    textTransform: "capitalize",
    fontFamily: "Jost",
    fontWeight: 600,
    borderRadius: "4px",
    padding: "12px 24px",
    "&:hover": {
      backgroundColor: "#45A045",
    },
  },
  "& .reject-btn": {
    backgroundColor: "#F44336",
    color: "#FFF",
    textTransform: "capitalize",
    fontFamily: "Jost",
    fontWeight: 600,
    borderRadius: "4px",
    padding: "12px 24px",
    "&:hover": {
      backgroundColor: "#E53935",
    },
  },
});

// Customizable Area End

import ChatController, { configJSON, IChat, Props } from "./ChatController";

export default class Chat extends ChatController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  renderLeftChatList = () => {
    const messages : {[key: string]: string} = {
      en: "Messages",
      fr: "Messages",
      es: "Mensajes",
      de: "Nachrichten",
    }
    const noActivePatients : {[key: string]: string} = {
      en: "No active patients",
      fr: "Aucun patient actif",
      es: "No hay pacientes activos",
      de: "Keine aktiven Patienten",
    }
    const Search : {[key: string]: string} = {
      "en": "Search",
      "fr": "Recherche",
      "de": "Suchen",
      "es": "Buscar"
    }
    return (
      <div
        style={{
          background: "white",
          alignSelf: "stretch",
          minHeight: 0,
          width: "34%",
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          borderRight: "1px solid lightgray",
        }}
      >
        <div
          style={{
            marginBottom: 32,
            marginLeft: 16,
            marginRight: 16,
            marginTop: 30,
            flexShrink: 0,
          }}
        >
          <span
            style={{
              fontFamily: "Jost",
              fontSize: "40px",
              lineHeight: "50px",
              fontWeight: 700,
              color: "#1F3650",
            }}
          >
            {messages[this.state.language]}
          </span>
        </div>
        <div style={{ marginBottom: 16, paddingLeft: 16, paddingRight: 16, flexShrink: 0 }}>
          <TextField
            fullWidth
            id="outlined-basic"
            variant="outlined"
            placeholder={Search[this.state.language]}
            value={this.state.searchText}
            onChange={this.handleSearch}
          />
        </div>

        <div
          data-testid="active-patient-list"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
          }}
        >
          {this.state.isPatientsLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
              <CircularProgress size={28} />
            </div>
          ) : null}
          {!this.state.isPatientsLoading && this.state.usersChatList.length === 0 ? (
            <span
              style={{
                padding: 16,
                color: "rgba(192, 192, 192, 0.9)",
                fontFamily: "Jost",
                fontSize: 16,
              }}
            >
              {noActivePatients[this.state.language] || noActivePatients.en}
            </span>
          ) : null}
          {this.state.usersChatList?.map((user, index) => {
            const filtered = this.state.patientsProfile.find(
              (profile) => profile.attributes.quickblox_id == user.user_id
            );
            return (
              <UserChat
                key={user._id || index}
                testId="createDialog"
                isShowTick={user?.unread_messages_count}
                selectedQuickBloxId={this.state.selectedQuickBloxId}
                isSelectedUser={this.state.isSelectedUser}
                user={user}
                createDialog={this.openPatientChat}
                getMessagesList={this.state.getChatsList}
                QB={this.QB}
                userProfile={
                  filtered || {
                    attributes: { profile_image: user.profile_image },
                  }
                }
              />
            );
          })}
        </div>
      </div>
    );
  };
  // Customizable Area End

  render() {
    // Customizable Area Start
    const sessionExp : {[key: string]: string} = {
      en: "Chat Session Expired",
      fr: "Session de discussion expirée",
      es: "La sesión de chat expiró",
      de: "Chat-Sitzung abgelaufen",
    }
    const loginAgain : {[key: string]: string} = {
      en: "Please Login Again",
      fr: "Veuillez vous reconnecter",
      es: "Por favor inicie sesión nuevamente",
      de: "Bitte melden Sie sich erneut an",
    }
    const Yes : {[key: string]: string} = {
      en: "Yes",
      fr: "Oui",
      es: "Si",
      de: "Ja",
    }
    const No : {[key: string]: string} = {
      en: "No",
      fr: "Non",
      es: "No",
      de: "Nein",
    }
    const chatUnavailable : {[key: string]: string} = {
      en: "Chat is not available for this patient yet.",
      fr: "Le chat n'est pas encore disponible pour ce patient.",
      es: "El chat aún no está disponible para este paciente.",
      de: "Der Chat ist für diesen Patienten noch nicht verfügbar.",
    }
    const noMessages : {[key: string]: string} = {
      en: "No messages yet",
      fr: "Pas encore de messages",
      es: "Aún no hay mensajes",
      de: "Noch keine Nachrichten",
    }
    const Conversation : {[key: string]: string} = {
      en: "Conversation with",
      fr: "Conversation avec",
      es: "Conversación con",
      de: "Gespräch mit",
    }
    const sendMessage : {[key: string]: string} = {
      en: "Send message...",
      fr: "Envoyer un message",
      es: "enviar mensaje",
      de: "Nachricht senden",
    }
    const Mic : {[key: string]: string} = {
      en: "Mic",
      fr: "Micro",
      es: "micrófono",
      de: "Mikrofon",
    }    
    const Leave : {[key: string]: string} = {
      en: "Leave",
      fr: "Partir",
      es: "Dejar",
      de: "Verlassen",
    }
    const IncomingCall : {[key: string]: string} = {
      en: "Incoming Call from",
      fr: "Appel entrant de",
      es: "Llamada entrante de",
      de: "Eingehender Anruf von",
    }
    const acceptCall : {[key: string]: string} = {
      en: "Would you like to accept?",
      fr: "Souhaitez-vous accepter",
      es: "¿Quieres aceptar?",
      de: "Möchten Sie annehmen",
    }
    const Decline : {[key: string]: string} = {
      en: "Decline",
      fr: "Déclin",
      es: "Rechazar",
      de: "Abfall",
    }
    const Accept : {[key: string]: string} = {
      en: "Accept",
      fr: "Accepter",
      es: "Aceptar",
      de: "Akzeptieren",
    }
    return (
      <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <SideNavbar
          navigation={this.props.navigation}
          id={this.props.id}
          showStudy={true}
          showButtonChats
          showButtonNotification
          language={this.state.language}
          handleLanguageSwitch={this.handleLanguageSwitch}
        />
        <Dialog
          open={this.state.logoutFlag}
          maxWidth={"xs"}
          fullWidth
          aria-labelledby="responsive-dialog-title"
        >
          <PasswordDialogStyle>
            <DialogActions>
              <IconButton
                onClick={() => this.setState({ logoutFlag: false })}
                data-testid="logout-chat"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-playstation-x"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z" />
                  <path d="M8.5 8.5l7 7" />
                  <path d="M8.5 15.5l7 -7" />
                </svg>
              </IconButton>
            </DialogActions>
            <DialogTitle>
              <Typography className="dialog-title">
                {sessionExp[this.state.language]}
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Typography className="dialog-para">
                {loginAgain[this.state.language]}
              </Typography>
            </DialogContent>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "20px",
              }}
            >
              <Button
                data-testid="handleLogout"
                style={{ width: "100%", margin: "30px" }}
                onClick={this.handleLogout.bind(this)}
                type="reset"
                variant="outlined"
                className="change-password-btn"
              >
                {Yes[this.state.language]}
              </Button>
              <Button
                data-testid="logOut"
                type="reset"
                style={{ width: "100%", margin: "30px" }}
                onClick={() => this.setState({ logoutFlag: false })}
                className="change-password-btn"
                variant="outlined"
              >
                {No[this.state.language]}
              </Button>
            </div>
          </PasswordDialogStyle>
        </Dialog>
        <ContainerBox>
          <Sidebar
            navigation={this.props.navigation}
            id={"task_list"}
            selected="messages"
            language={this.state.language}
          />
          {!this.state.isOpenAudioCall ? (
            <div style={{ flex: 1, minWidth: 0, minHeight: 0, alignSelf: "stretch", overflow: "hidden", display: "flex", alignItems: "stretch" }}>
                {this.renderLeftChatList()}

               {
                (this.state.getChatsList.length > 0 || this.state.isChatOkay) && 
                <div style={{ background: "white", flex: 1, minWidth: 0, minHeight: 0, alignSelf: "stretch", display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    <div style={{ flexShrink: 0, marginTop: 16 }}>
                      <div
                        style={{
                          display: "flex",
                          height: 60,
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "0 16px 16px 16px",
                          borderBottom: "1px solid lightgray",
                        }}
                      >
                        <Avatar
                          style={{ marginRight: 8 }}
                          alt="Remy Sharp"
                          src= {this.state.chatProfile}/>
                        <span
                          style={{
                            fontFamily: "Jost",
                            fontSize: "16px",
                            lineHeight: "26px",
                            fontWeight: 600,
                            color: "lightgray",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {Conversation[this.state.language]}{" "}
                          <span style={{ fontWeight: 700, color: "#1F3650" }}>
                            {this.state.receiverChatObj?.patient_id || this.state.receiverChatObj?.name}
                          </span>
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        overflow: "auto",
                        flex: 1,
                        minHeight: 0,
                        padding: 16,
                        scrollbarWidth: "none",
                        display: "flex",
                        flexDirection: this.state.firebaseChatId ? "column-reverse" : "column",
                        alignItems: this.state.firebaseChatId ? "stretch" : "center",
                        justifyContent: this.state.firebaseChatId ? "flex-start" : "center",
                      }}
                    >
                      {this.state.isMessagesLoading ? (
                        <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
                          <CircularProgress size={28} />
                        </div>
                      ) : null}
                      {!this.state.isMessagesLoading && !this.state.firebaseChatId ? (
                        <div
                          style={{
                            maxWidth: 420,
                            textAlign: "center",
                            fontFamily: "Jost",
                            background: "#F4F7FB",
                            borderRadius: 12,
                            padding: "28px 32px",
                          }}
                        >
                          <span style={{ display: "block", color: "#1F3650", fontSize: 16, fontWeight: 600, lineHeight: "24px" }}>
                            {chatUnavailable[this.state.language] || chatUnavailable.en}
                          </span>
                        </div>
                      ) : null}
                      {!this.state.isMessagesLoading && this.state.firebaseChatId && this.state.getChatsList.length === 0 ? (
                        <span style={{ fontFamily: "Jost", color: "#1F3650", textAlign: "center" }}>
                          {noMessages[this.state.language] || noMessages.en}
                        </span>
                      ) : null}
                      {this.state.getChatsList.map((chat: any, index: number) => {
                        const currentMessageDate = new Date(chat?.created_at).toDateString();
                        const previousMessageDate = new Date(this.state.getChatsList[index + 1]?.created_at).toDateString();
                        const showDate = currentMessageDate !== previousMessageDate;
                        return (
                          <ChatItem
                            key={chat.id || index}
                            receiverId={this.state.receiverIdChat}
                            senderId={chat.sender_id}
                            message={chat.message}
                            senderInfo={this.state.loginInfo}
                            chatInfo={chat}
                            receiverInfo={this.state.receiverChatObj}
                            selectedFileName={this.state.selectedFileName}
                            selectedFileType={this.state.selectedFileType}
                            filePreviewUrl={this.state.filePreviewUrl}
                            selectedFilePreview={this.state.selectedFilePreview}
                            QB={this.QB}
                            filesResult={this.state.filesResult}
                            showDate={showDate}
                            index={index}
                            chatProfile={this.state.chatProfile}
                            />
                        );
                      })}
                    </div>
                    <div
                      style={{
                        flexShrink: 0,
                        padding: "0px 16px 16px 16px",
                      }}
                    >
                      <TextField
                        fullWidth
                        value={this.state.chatMessageVal}
                        onChange={this.handleChatMessageChange}
                        onKeyDown={this.handleKeyDown}
                        InputProps={{
                          endAdornment: (
                            <MySendRoundedIcon
                              onClick={this.handleSendMessage.bind(this)} />
                          ),
                        }}
                        placeholder={sendMessage[this.state.language]} 
                        id="outlined-basic"
                        variant="outlined" />
                    </div>
                  </div>
               }
            </div>
          ) : (
            <>
              <Grid style={{ height: "100%" }} container>
                <Grid item xs={8} style={{ marginTop: 30 }}>
                  <div
                    style={{
                      display: "flex",
                      height: 60,
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "0 16px 16px 16px",
                      borderBottom: "1px solid lightgray",
                    }}
                  >
                    <Avatar
                      style={{ marginRight: 8 }}
                      alt="Remy Sharp"
                      src={this.state.chatProfile}
                    />
                    <span
                      style={{
                        fontFamily: "Jost",
                        fontSize: "16px",
                        lineHeight: "26px",
                        fontWeight: 600,
                        color: "lightgray",
                        flex: 1,
                      }}
                    >
                      {Conversation[this.state.language]}{" "}
                      <span style={{ fontWeight: 700, color: "black" }}>
                        {this.state.receiverChatObj?.name}
                      </span>
                    </span>
                    <Box display={"flex"} alignItems={"center"} width={"28%"}>
                      {!this.state.isOpenMic ? (
                        <MicOffOutlinedIcon
                          data-testid="handleMicOnn"
                          onClick={this.handleMicOn}
                          style={webStyles.micBtnStyle}
                        />
                      ) : (
                        <MicNoneOutlinedIcon
                          data-testid="handleMicOff"
                          onClick={this.handleMicOff}
                          style={webStyles.micBtnStyle}
                        />
                      )}
                      <Typography
                        variant="subtitle1"
                        style={{
                          color: "lightgray",
                          fontWeight: 800,
                          paddingRight: "25px",
                        }}
                      >
                        {Mic[this.state.language]}
                      </Typography>
                      <Button
                        data-testid="handleLeaveCall"
                        onClick={this.handleLeaveCall}
                        style={{
                          backgroundColor: "#A776FB",
                          color: "white",
                          border: "1px solid #A776FB",
                          borderRadius: "8px",
                          height: "50px",
                        }}
                      >
                        {Leave[this.state.language]}
                      </Button>
                    </Box>
                  </div>
                  {/* Users Audio Call */}
                  <Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "55%",
                        paddingTop: "15%",
                      }}
                    >
                      <Avatar
                        style={{
                          marginRight: 8,
                          height: "130px",
                          width: "130px",
                        }}
                        alt="Remy Sharp"
                        src={this.state.chatProfile}
                      />
                    </Box>

                    <Box
                      display={"flex"}
                      justifyContent={"flex-end"}
                      pr={"10%"}
                    >
                      <Avatar
                        style={{
                          marginRight: 8,
                          height: "130px",
                          width: "130px",
                        }}
                        alt="Remy Sharp"
                        src={this.state.profileImagePic}
                      />
                    </Box>
                  </Grid>
                </Grid>
                {/* Chats */}
                <Grid
                  item
                  xs={4}
                  style={{
                    overflowY: "auto",
                    height: "calc(100vh - 60px)",
                    padding: 16,
                    scrollbarWidth: "none",
                    display: "flex",
                    flexDirection: "column-reverse",
                    borderLeft: "1px solid lightgray",
                  }}
                >
                  <div>
                    <TextField
                      onKeyDown={this.handleKeyDown}
                      value={this.state.chatMessageVal}
                      onChange={this.handleChatMessageChange}
                      InputProps={{
                        endAdornment: (
                          <MySendRoundedIcon
                            onClick={this.handleSendMessage.bind(this)} />
                        ),
                      }}
                      style={{ width: '100%'}}
                      id="outlined-basic"
                      variant="outlined"
                      placeholder={sendMessage[this.state.language]} />
                  </div>
                  {this.state.getChatsList?.map((chat: any, index: number) => {
                  const currentMessageDate = new Date(chat?.created_at).toDateString();
                  const previousMessageDate =  new Date(this.state.getChatsList[index + 1]?.created_at).toDateString() 
                  const showDate = currentMessageDate !== previousMessageDate;
                    return (
                      <ChatItem
                        filePreviewUrl={this.state.filePreviewUrl}
                        selectedFileName={this.state.selectedFileName}
                        message={chat.message}
                        chatInfo={chat}
                        QB={this.QB}
                        senderId={chat.sender_id}
                        receiverId={this.state.receiverIdChat}
                        receiverInfo={this.state.receiverChatObj}
                        filesResult={this.state.filesResult}
                        senderInfo={this.state.loginInfo}
                        showDate={showDate}
                        selectedFilePreview={this.state.selectedFilePreview}
                        selectedFileType={this.state.selectedFileType}
                        index={index}
                        chatProfile={this.state.chatProfile}
                      />
                    );
                  })}
                </Grid>
              </Grid>
            </>
          )}
        </ContainerBox>
        <Dialog
          open={this.state.iOpenAcceptRejectPage}
          maxWidth={"xs"}
          fullWidth
          aria-labelledby="responsive-dialog-title"
        >
          <PasswordDialogStyle>
            <DialogTitle className="dialog-header">
              <Typography className="dialog-title">
                {IncomingCall[this.state.language]} {this.state.callingUser.name || "Unknown"}
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Typography className="dialog-message">{acceptCall[this.state.language]}</Typography>
            </DialogContent>
            <DialogActions className="dialog-actions">
              <Button
                data-testid="handleRejectCall"
                style={{
                  width: "100%",
                  margin: "30px",
                  color: "white",
                  backgroundColor: "red",
                }}
                onClick={this.handleRejectCall.bind(this)}
                type="reset"
                variant="outlined"
                className="change-password-btn"
              >
                {Decline[this.state.language]}
              </Button>
              <Button
                data-testid="handleAcceptCall"
                type="reset"
                style={{
                  width: "100%",
                  margin: "30px",
                  color: "white",
                  backgroundColor: "green",
                }}
                onClick={this.handleAcceptCall.bind(this)}
                className="change-password-btn"
                variant="outlined"
              >
                {Accept[this.state.language]}
              </Button>
            </DialogActions>
          </PasswordDialogStyle>
        </Dialog>
        {
          this.state.isLoading && (
            <Box
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundColor: '#00000054',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <CircularProgress />
            </Box>
          )
        }
      </div>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const webStyles = {
  createButtonView: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0px",
    marginBottom: 20,
  },
  roomListContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  listItemContainer: {
    width: 300,
    border: "2px solid #ccc",
    borderRadius: 10,
    padding: 15,
    marginBottom: 20,
  },
  modalContainer: {
    display: "flex",
    flexDirection: "row",
    position: "absolute" as "absolute",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 300,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  },
  modalButtonView: {
    marginLeft: 10,
  },
  mutedChat: {
    backgroundColor: "lightgray",
  },
  micBtnStyle: {
    marginRight: 16,
    height: "30px",
    width: "30px",
    color: "lightgray",
    cursor: "pointer",
  },
};

const ContainerBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  width: "100%",
  flex: "1 1 0",
  minHeight: 0,
  overflow: "hidden",
});

const MySendRoundedIcon = styled(SendRoundedIcon)({
  cursor: "pointer",
});
// Customizable Area End
